import { ON_FULFILLMENT_OFFERINGS_SUCCESS } from '../../action-types';

export default function warningsReducer(state = [], action = {}) {
  switch (action.type) {
    case ON_FULFILLMENT_OFFERINGS_SUCCESS: {
      return action.payload.fulfillmentOfferings?.warnings || [];
    }
    default:
      return state;
  }
}
